import { Component, OnInit, AfterContentInit, AfterViewInit, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { SessionBookingVM } from '../../../models/SessionBookingVM';
import { SessionCreditVM } from '../../../models/SessionCreditVM';

@Component({
    selector: 'b2b-session-payment',
    templateUrl: './b2b-sessionpayment.component.html'
})
export class B2BSessionPaymentComponent extends BaseComponent implements OnInit {

    @Input() sessionDetails: SessionBookingVM | null = null;
    @Output() bookingResponse: EventEmitter<Response> = new EventEmitter();
    isTermsAccepted = false;
    creditDetails: SessionCreditVM = null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private accService: AccountService
    ) {
        super(route);
    }

    ngOnInit(): void {
        if (this.sessionDetails.payWithCredits) {
            //check if credits are still valid    
            var self = this;
            self.emitDisplayLoadingDialog(true);
            this.sessionDetails.duration
            this.accService.getSessionCreditsByProfessional(this.sessionDetails.mbNumber)
                .subscribe(
                    r => {
                        var stillHasCredits = false;
                        r.forEach((item, i) => {
                            if (item.duration == self.sessionDetails.duration) {
                                stillHasCredits = true;
                                self.creditDetails = item;
                            }
                        });

                        if (!stillHasCredits) {
                            this.router.navigateByUrl("/");
                        }

                        self.emitDisplayLoadingDialog(false);
                    },
                    e => {
                        console.log(e);
                        this.router.navigateByUrl("/");
                        self.emitDisplayLoadingDialog(false);
                    },
                    () => { }
                );
        }
        else {
            this.router.navigateByUrl("/");
        }
    }

    termsCheckboxChange(chkbox: boolean) {
        this.isTermsAccepted = chkbox;
    }

    commitBooking() {
        const name = this.me.username;
        this.emitDisplayLoadingDialog(true);

        this.accService.commitBooking(this.sessionDetails)
            .subscribe(
                (returnValue) => {
                    this.accService.newSessionBooking = null;
                    this.bookingResponse.emit(returnValue);
                },
                e => {
                    this.bookingResponse.emit(e);
                },
                () => { }
            );

        return false;
    }
}
